'use client';

import { Divider } from '@andritzot/metris-web-ui/data-display/divider';
import type { SvgIconProps } from '@andritzot/metris-web-ui/data-display/svgicon';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import type { ComponentType } from 'react';

type ProfileModelProps = {
  icon: ComponentType<SvgIconProps>;
  title: string;
  data?: string;
};

const ProfileModel = ({ icon: Icon, title, data }: ProfileModelProps) => {
  return (
    <>
      <Box sx={{ px: 4, py: '0.65rem', alignItems: 'center', display: 'flex' }}>
        <Box sx={{ display: 'inline-flex', flexShrink: 0, pr: 4, color: 'text.secondary' }}>
          <Icon fontSize="small" />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography component="h5" sx={{ fontWeight: 600, fontSize: '1.15rem', m: 0, p: 0 }}>
            {title}
          </Typography>
          <Typography
            component="span"
            sx={{
              fontWeight: 500,
              fontSize: '0.95rem',
              '&:hover': { color: 'primary.main', transition: 'color 0.2s ease' },
            }}
          >
            {data}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ borderColor: '#eff2f5', my: '0.5rem' }} />
    </>
  );
};

export default ProfileModel;
